import { InjectionToken } from '@angular/core';

export const KITCHEN_API_URL = new InjectionToken<string>('KITCHEN_API_URL');
